/**
 * The host adapter for the `send-to-opener` client-side entity (ADR-037 D8).
 * The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId, holderId }`; the plugin renderer that mounted an arche
 * registers here the function that draws ITS send sheet, and the executor
 * reaches it by arche id. An arche with no mounted renderer answers
 * SEND_UNAVAILABLE.
 */

import type { SendToOpenerHost, SendToOpenerResult } from '@fias/client-entities';

type SendHandler = (request: {
  holderId: string | null;
  fileId: string;
  name: string | null;
}) => Promise<SendToOpenerResult>;

const handlers = new Map<string, SendHandler>();

/** Called by the plugin renderer on mount; returns the unregister function. */
export function registerSendToOpener(archeId: string, handler: SendHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const sendToOpenerHost: SendToOpenerHost = {
  async showSendToOpener({ archeId, holderId, fileId, name }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: {
          code: 'SEND_UNAVAILABLE',
          message: 'Sending to another arche is not available here',
        },
      };
    }
    return handler({ holderId, fileId, name });
  },
};
